<template>
    <div class="body_bg">
        <!-- socket sidebar -->
        <soc-sidebar />

        <div class="nuxt-page-view" :class="{ mobile: isMobile }">
            <div class="w-full py-8 px-4">
                <sidebar-mobile-menu />
                <NuxtPage />
            </div>
        </div>
    </div>
</template>

<script setup>
import SocSidebar from '~/components/layout/SocSidebar/SocSidebar.vue'
import SidebarMobileMenu from '~/components/layout/SocSidebar/SidebarMobileMenu.vue';

const isMobile = ref(false);

// Check if we're on mobile/tablet
onMounted(() => {
    const checkMobile = () => {
        isMobile.value = window.innerWidth < 1025;
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    onUnmounted(() => {
        window.removeEventListener('resize', checkMobile);
    });
});
</script>

<style lang="scss" scoped>
.nuxt-page-view {
    @apply ml-80;
    height:100vh;
    transition: margin-left 0.3s ease-in-out;

    &.mobile {
        margin-left: 0;
    }
    @media screen and (max-width: 1024px) {
        margin-left: 0;
    }
}
.body_bg {
    background: url('/assets/images/soc/body_bg.png');
    background-color: #18181B;
    height: 100vh;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-attachment: fixed;
    overflow:auto;
}
</style>
